import Skills from "./Skills";
import Tools from "./Tools";

function About() {
    return (
        <main>
            <section className="relative py-20 md:pt-32">
                <picture className="pointer-events-none absolute inset-0 -z-10">
                    <img src="img/gradient_dark.jpg" alt="gradient dark" className="h-full w-full" />
                </picture>
                <div className="container relative z-10">
                    <div className="text-center pt-24 text-center">
                        <h1 className="mb-6 font-display text-5xl text-white lg:text-6xl">
                            About Me
                        </h1>
                        <p className="text-lg leading-normal text-khi-50 text-center">
                            Hi, I'm Wajahat Rana, <span className="animate-gradient font-bold">Fullstack Developer</span> and <span className="animate-gradient font-bold">UI/UX Designer</span> passionate about crafting seamless digital experiences. With expertise in HTML, CSS, JavaScript, React, Node JS, PHP, MySQL, SQL Server, and Postgres, I specialize in building responsive and intuitive websites and web applications. I love transforming ideas into code.
                        </p>
                    </div>
                </div>
            </section>
            <section className="pt-10 pb-24">
                <div className="container">
                    <div className="mb-20 text-center">
                        <h1 className="font-display text-5xl text-white lg:text-6xl">Skills</h1>
                        <p className="text-lg leading-normal text-khi-50 text-center">Every line of code is a step towards turning ideas into reality.</p>
                    </div>
                    <Skills />
                </div>
            </section>
            <section className="py-24 dark:bg-khi-800">
                <div className="container">
                    <div className="mb-20 text-center">
                        <h1 className="font-display text-5xl text-white lg:text-6xl">Tools and Technologies</h1>
                        <p className="text-lg leading-normal text-khi-50 text-center">Tools and Technologies That I Used in My Career.</p>
                    </div>
                    <Tools />
                </div>
            </section>
        </main>
    )
}

export default About